module.exports = __webpack_public_path__ + "img/img_close.74df604.svg";